import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import { axiosPrivate } from "../../Helpers/axios";
import { maskMobileNumber } from "../../utils/MobileNumHide";

function* getTransactionsDataResponse({
  payload: { agentId, offset, limit, search, fromDate, toDate, status },
}) {
  try {
    if (agentId?.length > 0) {
      const response = yield call(
        axiosPrivate.get,
        `/api/cou-dashboard/transactions?agentId=${agentId}&page=${
          offset ? offset : 1
        }&limit=${limit ? limit : 10}${search ? `&search=${search}` : ""}${
          fromDate ? `&fromDate=${encodeURIComponent(fromDate)}` : ""
        }${toDate ? `&toDate=${encodeURIComponent(toDate)}` : ""}${
          status ? `&status=${status}` : ""
        }`
      );

      if (response.status === 200) {
        yield put(actions.getTransactionsDataSuccess(response.data));
      } else {
        yield put(actions.getTransactionsDataFailed(response.message));
      }
    }
  } catch (error) {
    yield put(actions.getTransactionsDataFailed(error));
  }
}

// function to get all transactions
function* getAllTransactionsDataResponse({
  payload: { agentId, offset, limit, search, fromDate, toDate },
}) {
  try {
    if (agentId?.length > 0) {
      const response = yield call(
        axiosPrivate.get,
        `/api/cou-dashboard/transactions?agentId=${
          agentId ? agentId : ""
        }&page=${offset ? offset : 1}${limit ? `&limit=${limit}` : ""}${
          search ? `&search=${search}` : ""
        }${fromDate ? `&fromDate=${fromDate}` : ""}${
          toDate ? `&toDate=${toDate}` : ""
        }`
      );
      if (response.status === 200) {
        yield put(
          actions.getAllTransactionsDataSuccess(
            response.data,
            response.data.total
          )
        );
      } else {
        yield put(actions.getAllTransactionsDataFailed(response.message));
      }
    }
  } catch (error) {
    yield put(actions.getAllTransactionsDataFailed(error));
  }
}

function* getChartDataResponse({ payload: { agentId } }) {
  try {
    if (agentId.length > 0) {
      const response = yield call(
        axiosPrivate,
        `/api/cou-dashboard/transactions/graph?agentId=${
          agentId ? agentId : ""
        }`
      );
      yield put(actions.getChartDataSuccess(response?.data));
    }
  } catch (error) {
    yield put(actions.getChartDataFailed(error?.response?.data?.message));
  }
}

function* getDailyChartDataResponse({ payload: { agentId } }) {
  try {
    if (agentId.length > 0) {
      const response = yield call(
        axiosPrivate,
        `/api/cou-dashboard/transactions/daily-graph?agentId=${
          agentId ? agentId : ""
        }`
      );
      yield put(actions.getDailyChartDataSuccess(response?.data));
    }
  } catch (error) {
    yield put(actions.getDailyChartDataFailed(error?.response?.data?.message));
  }
}

// piechart
function* getPieChartDataResponse({ payload: { agentId } }) {
  try {
    if (agentId.length > 0) {
      const response = yield call(
        axiosPrivate,
        `/api/cou-dashboard/transactions/piechart?agentId=${
          agentId ? agentId : ""
        }`
      );
      yield put(actions.getPieChartDataSuccess(response?.data));
    }
  } catch (error) {
    yield put(actions.getPieChartDataFailed(error?.response?.data?.message));
  }
}

// function get all transaction logs / details
function* getFullTransactionDetails({ payload: { refId } }) {
  try {
    const response = yield call(
      axiosPrivate,
      `/api/cou-dashboard/transactions/full-transaction-history/${refId}`
    );
    if (response.status === 201 || response.status === 200) {
      response.data.request.customerMobile =
        response.data.request.customerMobile;

      yield put(actions.getFullTransactionsDetailsSuccess(response.data));
    } else {
      yield put(actions.getFullTransactionDetailsError(response));
    }
  } catch (error) {
    yield put(actions.getFullTransactionDetailsError(error?.response?.data));
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.GET_TRANSACTIONS_DATA, getTransactionsDataResponse),
  ]);
  yield all([
    takeEvery(
      actions.GET_ALL_TRANSACTIONS_DATA,
      getAllTransactionsDataResponse
    ),
  ]);
  yield all([takeEvery(actions.GET_CHART_DATA, getChartDataResponse)]);
  yield all([
    takeEvery(actions.GET_DAILY_CHART_DATA, getDailyChartDataResponse),
  ]);
  yield all([takeEvery(actions.GET_PIE_CHART_DATA, getPieChartDataResponse)]);
  yield all([
    takeEvery(actions.GET_FULL_TRANSACTIONS_DETAILS, getFullTransactionDetails),
  ]);
}
